const getCanonicalNanpPhoneNumber = (value?: string | null): string | null => {
  const trimmedValue = (value || "").trim();

  if (!trimmedValue || !/^[0-9+().\s./-]+$/.test(trimmedValue)) {
    return null;
  }

  const plusMatches = trimmedValue.match(/\+/g) || [];
  if (
    plusMatches.length > 1 ||
    (plusMatches.length === 1 && !trimmedValue.startsWith("+1"))
  ) {
    return null;
  }

  const digits = trimmedValue.replace(/\D/g, "");
  if (digits.length === 10 && plusMatches.length === 0) {
    return digits;
  }

  return digits.length === 11 && digits.startsWith("1")
    ? digits.slice(1)
    : null;
};

export const formatMemberPhoneNumberForInput = (
  value?: string | null
): string => {
  const canonicalPhoneNumber = getCanonicalNanpPhoneNumber(value);

  return canonicalPhoneNumber
    ? `(${canonicalPhoneNumber.slice(0, 3)}) ${canonicalPhoneNumber.slice(
      3,
      6
    )}-${canonicalPhoneNumber.slice(6)}`
    : value || "";
};
